import { gql } from 'graphql-request';

export default gql`query($filter: FilterInput) {
    console(filter: $filter) {
        id
        name
        mn_label
        typical_value
        file_path
    }
}`;